import { render, staticRenderFns } from "./SidebarUser.vue?vue&type=template&id=29910965&scoped=true&"
import script from "./SidebarUser.vue?vue&type=script&lang=ts&"
export * from "./SidebarUser.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarUser.vue?vue&type=style&index=0&id=29910965&lang=scss&scoped=true&"
import style1 from "./SidebarUser.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29910965",
  null
  
)

export default component.exports